import { useState } from 'react'
import { LogOut, Menu } from 'lucide-react'
import { BadgePendencias } from '../pendencias/BadgePendencias'
import { useUsuario } from '../../contexts/UsuarioContext'
import { ModalPerfil } from '../perfil/ModalPerfil'

function getInitials(nome: string): string {
  if (!nome) return '?'
  const parts = nome.trim().split(' ')
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

interface AppHeaderProps {
  onOpenSidebar: () => void
}

export function AppHeader({ onOpenSidebar }: AppHeaderProps) {
  const { usuario, logout } = useUsuario()
  const [isPerfilModalOpen, setIsPerfilModalOpen] = useState(false)
  const primeiroPapel = usuario?.papeisNomes?.[0] || usuario?.papeis?.[0] || 'Usuário'
  const fotoUrl = usuario?.fotoUrl
    ? `${import.meta.env.VITE_API_URL || 'http://localhost:5160/api'}${usuario.fotoUrl}`
    : null

  const handleFotoClick = () => {
    setIsPerfilModalOpen(true)
  }

  return (
    <header className="sticky top-0 z-30 flex w-full border-b border-gray-200 bg-white shadow-sm">
      <div className="flex w-full items-center justify-between px-4 py-4 md:px-6 2xl:px-11">
        {/* Mobile Menu Button */}
        <div className="flex items-center gap-2 sm:gap-4 lg:hidden">
          <button
            type="button"
            onClick={onOpenSidebar}
            className="block rounded-md border border-gray-200 bg-white p-2 text-gray-700 shadow-sm transition-colors hover:bg-gray-100"
          >
            <Menu className="h-5 w-5" />
          </button>
        </div>

        {/* Header Actions */}
        <div className="ml-auto flex items-center gap-3 2xsm:gap-7">
          <ul className="flex items-center gap-2 2xsm:gap-4">
            <BadgePendencias />
          </ul>

          {/* User Menu */}
          {usuario && (
            <div className="relative flex items-center gap-3">
              <div className="flex items-center gap-3">
                <button
                  onClick={handleFotoClick}
                  className="h-12 w-12 rounded-full flex items-center justify-center overflow-hidden cursor-pointer hover:opacity-80 transition-opacity"
                  title="Meu Perfil"
                >
                  {fotoUrl ? (
                    <img
                      src={fotoUrl}
                      alt={usuario.nome}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement
                        target.style.display = 'none'
                        if (target.nextElementSibling) {
                          ;(target.nextElementSibling as HTMLElement).style.display = 'flex'
                        }
                      }}
                    />
                  ) : null}
                  <div
                    className={`w-full h-full flex items-center justify-center text-white font-medium text-sm bg-brand-500 ${fotoUrl ? 'hidden' : ''}`}
                  >
                    {getInitials(usuario.nome)}
                  </div>
                </button>
                <span className="hidden text-left lg:block">
                  <span className="block text-sm font-medium text-gray-900">{usuario.nome}</span>
                  <span className="block text-xs text-gray-500">{primeiroPapel}</span>
                </span>
              </div>
              <button
                onClick={logout}
                className="flex h-10 w-10 items-center justify-center rounded-md text-gray-700 transition-colors hover:bg-gray-100"
                title="Sair"
              >
                <LogOut className="w-5 h-5" />
              </button>
            </div>
          )}
        </div>
      </div>
      <ModalPerfil isOpen={isPerfilModalOpen} onClose={() => setIsPerfilModalOpen(false)} />
    </header>
  )
}
